// import { Component, HostListener, OnInit } from '@angular/core';
import {
  Component,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable, Subject, Subscription, forkJoin, interval } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class Navbar implements OnInit {
  loadingData = true;
  onl_button: any;
  isSmall: boolean;
  isBig = true;
  isLeft = true;
  isMiddle = false;
  subscription: Subscription;
  currentDay: string;
  currentTime: string;
  currentDate: string;
  Notices = [];
  array1 = [];
  array2 = [];
  currentDateTime$: Observable<string>;
  mainData: any;
  sortedNotice: any;
  private ngUnsubscribe = new Subject();
  @Output() parametersReady = new EventEmitter<any>();
  AllmenuItems: any[];
  client_basis: any;

  constructor(
    private appService: AppService,
    private emitterService: EmitterService
  ) {
    this.smallScreen();
  }

  ngOnInit(): void {
    this.currentDateTime$ = interval(1000).pipe(
      map(() => {
        const currentDate = new Date();
        const dayOfWeek = this.getDayOfWeek(currentDate);
        const time = this.getTime(currentDate);
        const month = this.getMonth(currentDate);
        const day = currentDate.getDate();
        const year = currentDate.getFullYear();
        return `${dayOfWeek} ${" | "}  ${time}  ${" | "}   ${month} ${day}, ${year}`;
      })
    );

    this.FetchMainData();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchMainData() {
    forkJoin([this.appService.getClientBasics(), this.appService.getNotices()])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response: any) => {
          console.log(response, "response FetchMainData");

          this.mainData = response[0].data;
          this.client_basis = response[0].data.LocalOptions;
          console.log(this.client_basis, "Home Basis");

          this.sortedNotice = this.sortByStartDate(response[1].data);
          console.log(this.sortedNotice, "Sorted Notices");
          //
          if (this.client_basis != null) {
            let abc_button = this.client_basis.filter(
              (x) => x.DisplayName === "Online Admission"
            );

            this.onl_button = abc_button[0];
            console.log(this.onl_button,"Button Data")
          }
          if (this.sortedNotice != null) {
            let scrollFiltered = this.sortedNotice.filter(
              (x) => x.ShowScroll === true && x.IsActive === true
            );

            this.Notices = scrollFiltered.sort((a, b) => b.Id - a.Id);
          }
          // With all menu items
          if (this.mainData != null) {
            let siteMapSorted = [];
            // except welcome
            let newArraay = [];

            this.mainData.SiteMapList.forEach((item) => {
              if (item.MenuCode != 187 && item.MenuCode != 188 && item.MenuCode != 647) {
                newArraay.push({
                  ...item,
                  Items: [],
                });
              }
            });
            // except welcome ends

            console.log(newArraay, "All menu exept Welcome");

            console.log(siteMapSorted, "SiteMap list");

            // Initialize parent items with ParentId === 0
            newArraay.forEach((item) => {
              if (item.ParentId === 0) {
                siteMapSorted.push({
                  ...item,
                  Items: [],
                });
              }
            });

            // Sort the parent items by MenuOrder in ascending order
            siteMapSorted.sort((a, b) => a.MenuOrder - b.MenuOrder);

            // Nest the child items under their respective parents
            newArraay.forEach((item) => {
              if (item.ParentId !== 0) {
                let parentItem = siteMapSorted.find(
                  (parent) => parent.Id === item.ParentId
                );
                if (parentItem) {
                  parentItem.Items.push(item);
                } else {
                  // If parent item not found, create a new parent item placeholder
                  parentItem = {
                    Id: item.ParentId,
                    MenuName: item.DisplayNameParent,
                    Items: [item],
                  };
                  siteMapSorted.push(parentItem);
                }
              }
            });

            // Sort the child items of each parent by MenuOrder (optional, if needed)
            siteMapSorted.forEach((parent) => {
              if (parent.MenuUrl && parent.MenuUrl.startsWith('http')) {
                parent.MenuCode = 11;
              }
              if (parent.Items.length > 0) {
                parent.Items.forEach((child: any) => {
                  if (child.MenuUrl) {
                    child.MenuUrl = child.MenuUrl.trim();
                    if (child.MenuUrl === 'message-of-head-master') {
                      child.MenuUrl = 'administration/message-of-head-master';
                    }
                    if (child.MenuUrl.startsWith('http')) {
                      child.MenuCode = 11;
                    }
                  }
                });
                parent.Items.sort((a, b) => a.MenuOrder - b.MenuOrder);
              }
            });

            this.AllmenuItems = siteMapSorted;
            console.log(this.AllmenuItems, "Menu Items");

            const middleIndex = Math.ceil(siteMapSorted.length / 2);

            this.array1 = siteMapSorted.slice(0, middleIndex);
            this.array2 = siteMapSorted.slice(middleIndex);

            localStorage.setItem("mainData", JSON.stringify(this.mainData));
          }
          // all menu items ends

          if (this.sortedNotice != null && this.mainData != null) {
            this.loadingData = false;
            this.emitterService.changeMessage(true);
            // this.parametersReady.emit(true);
          }
        },
        (error) => {
          // Handle errors
          console.error("Error:", error);
        }
      );
  }

  private getDayOfWeek(date: Date): string {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return days[date.getDay()];
  }

  private getTime(date: Date): string {
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes();
    const ampm = date.getHours() < 12 ? "AM" : "PM";
    return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
  }

  private getMonth(date: Date): string {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months[date.getMonth()];
  }

  @HostListener("window:resize")
  onResize() {
    this.smallScreen();
  }

  smallScreen() {
    this.isSmall = window.innerWidth < 1100;
    this.isBig = window.innerWidth > 1100;
    this.isLeft = window.innerWidth > 1200;
    this.isMiddle = window.innerWidth < 1000;
  }

  onNavigate(url: string) {
    let MyUrl = "";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      MyUrl = url;
    } else {
      MyUrl = "https://" + url;
    }
    window.open(MyUrl, "_blank");
  }

  NoAdmissionAlert() {
    alert("Admission services not open yet.");
    return;
  }

  private getTimeFull(date?: Date) {
    return date != null ? new Date(date).getTime() : 0;
  }

  public sortByStartDate(array: any): any {
    return array.sort((a: any, b: any) => {
      return this.getTimeFull(b.CreatedDate) - this.getTimeFull(a.CreatedDate);
    });
  }

  /** Toggle a parent item's mobile accordion open/closed */
  toggleMobileMenu(item: any): void {
    item._mobileOpen = !item._mobileOpen;
  }

  /** Close the offcanvas sidebar (called when a mobile menu link is tapped) */
  closeSidebar(): void {
    const win = window as any;
    if (win.$) {
      win.$('.offcanvas-area').removeClass('info-open');
      win.$('.offcanvas-overlay').removeClass('overlay-open');
      win.$('body').removeClass('nav-open');
    }
  }
}
